import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import "./VideoStreaming.css";
import { FaDotCircle } from "react-icons/fa";
import { openSuccessPopup } from "../../../Redux/Actions/PopupActions";
import { useDispatch, useSelector } from "react-redux";
import {
  setLiveChannelsList,
  updateLiveChannels,
} from "../../../Redux/Actions/VideoStreamingActions";

const VideoPlayer = ({ videoData }) => {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    streamVideo();

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }
    };
  }, [videoData]);

  const streamVideo = () => {
    if (Hls.isSupported() && videoRef.current) {
      hlsRef.current = new Hls();
      const video = videoRef.current;
      const hls = hlsRef.current;

      hls.loadSource(videoData?.playbackUrl);
      hls.attachMedia(video);

      let streamTimeout;

      hls.on(Hls.Events.MEDIA_ATTACHED, function () {
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          video.play();
          video.pause();
          streamTimeout = setTimeout(() => {
            openSuccessPopup(dispatch, {
              successPopUp: {
                message: `It Seems Like Video Streaming for ${videoData?.channelName} Has stopped, We are unable to Fetch Stream Data, Contact to your school admin for more information.`,
                open: true,
              },
            });
            updateLiveChannels(dispatch, {
              currentChannel: videoData,
              channelStatus: false,
            });
          }, 60000);
        });

        hls.on(Hls.Events.FRAG_LOADED, function () {
          clearTimeout(streamTimeout);
          streamTimeout = setTimeout(() => {
            openSuccessPopup(dispatch, {
              successPopUp: {
                message: `It Seems Like Video Streaming for ${videoData?.channelName} Has stopped, We are unable to Fetch Stream Data, Contact to your school admin for more information.`,
                open: true,
              },
            });
            updateLiveChannels(dispatch, {
              currentChannel: videoData,
              channelStatus: false,
            });
            video.pause();
          }, 60000);
        });

        hls.on(Hls.Events.ERROR, function (event, data) {
          console.error("Error while fetching video:", data);
        });
      });
    }
  };

  return (
    <div className="video-container bg-navyBlue position-relative">
      <div className="media-wrapper video-wrapper">
        <video
          ref={videoRef}
          controls={true}
          className="video-wrapper__video"
        />
      </div>
      <div className="mg-top-20 bg-white padding-10 rounded">
        <p className="semi-bold fs-20 text-center">{videoData?.channelName}</p>
      </div>
      {videoData?.assigned && (
        <span className="semi-bold live-icon-label d-flex-align-cent gap-5">
          <FaDotCircle />
          Live
        </span>
      )}
    </div>
  );
};

const VideoStreamingContainer = () => {
  const dispatch = useDispatch();
  const liveChannels = useSelector(
    (state) => state?.videoStreamData?.liveChannelsList
  );
  const loading = useSelector((state) => state?.LoadingData?.fullPageLoading);

  useEffect(() => {
    setLiveChannelsList(dispatch);
  }, []);

  const checkLiveChannels = () => {
    return liveChannels?.length > 0
      ? liveChannels?.filter((channel) => channel?.assigned === true)
      : [];
  };

  return (
    <div className="video-streaming-channel-grid mg-top-70 mg-bottom-20 padding-10">
      {!loading &&
        checkLiveChannels()?.map((videoData, index) => (
          <VideoPlayer key={index} videoData={videoData} />
        ))}
      {!loading && checkLiveChannels()?.length === 0 && (
        <h2 className="semi-bold white-card">
          No Live Streaming Channels Available
        </h2>
      )}
    </div>
  );
};

export default VideoStreamingContainer;
